import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {Directive} from '@angular/core';

/**
 * Checks if an input element only contains whitespace characters.
 * Can be used like this:
 * [dcpWhitespaceOnly]
 */

/**
 * Custom whitespace only validation directive that can be used to validate any input element.
 */
@Directive({
  selector: '[dcpWhitespaceOnly]',
  providers: [{provide: NG_VALIDATORS, useExisting: WhitespaceOnlyDirective, multi: true}]
})
export class WhitespaceOnlyDirective implements Validator {

  public static whitespaceOnlyValidator(control: AbstractControl) {
    let isValid: boolean = true;
    if (control && control.value) {
      const isWhitespace: boolean = (control.value || '').trim().length === 0;
      isValid = !isWhitespace;
    }
    return isValid ? null : {whitespaceOnly: true};
  }

  validate(control: AbstractControl): ValidationErrors {
    return WhitespaceOnlyDirective.whitespaceOnlyValidator(control);
  }
}

